<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Fornecedores</h1>
        <p class="text-sm text-gray-500">Gerencie seus fornecedores</p>
      </div>
      <button (click)="createSupplier()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Novo Fornecedor
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
      <input
        type="text"
        (input)="onSearchChange()"
        [(ngModel)]="searchTerm"
        placeholder="Buscar por razão social ou fantasia..."
        class="border border-gray-300 rounded px-3 py-2 text-sm"
      />
      <p-dropdown
        [options]="status"
        [(ngModel)]="selectedStatus"
        (onChange)="onStatusChange()"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o status"
        class="w-full text-sm"
      ></p-dropdown>
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} fornecedor(es) encontrado(s)
      </div>
    </div>
  </div>

  <div class="px-6 py-2"></div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="suppliers"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Razão Social</th>
            <th class="text-left px-6 py-3">Fantasia</th>
            <th class="text-left px-6 py-3">CNPJ</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-supplier let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-semibold text-gray-900">{{ supplier.companyName }}</td>
            <td class="px-6 py-2">{{ supplier.tradingName || '-' }}</td>
            <td class="px-6 py-2 font-mono">{{ supplier.cnpj || '-' }}</td>
            <td class="px-6 py-2">
              <span
                class="px-2 py-1 rounded-full text-xs"
                [ngClass]="{
                  'bg-green-100 text-green-800': supplier.active,
                  'bg-red-100 text-red-800': !supplier.active
                }"
              >
                {{ supplier.active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Editar"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(supplier)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-8 text-gray-500">
              Nenhum fornecedor encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
